import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

const THEME_KEY  = 'streamstack-theme';
const SCHEME_KEY = 'streamstack-scheme';

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() =>
    localStorage.getItem(THEME_KEY) || 'dark'
  );

  const [colorScheme, setColorSchemeState] = useState(() =>
    localStorage.getItem(SCHEME_KEY) || 'default'
  );

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-color-scheme', colorScheme);
    localStorage.setItem(SCHEME_KEY, colorScheme);
  }, [colorScheme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  const setColorScheme = (scheme) => setColorSchemeState(scheme);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colorScheme, setColorScheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
